import { SendHorizontal } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import type { FillApplicationState } from '@/models/fillApplication'
import { ConfirmLinkDialog } from '../ConfirmLinkDialog'
import { AuthorizationLinks } from './AuthorizationLinks'
import { CustomerSignInLink } from './CustomerSignInLink'
import { ViewOnlyLink } from './ViewOnlyLink'

export function CustomerLinksCard({ orgId, state }: { orgId: string; state: FillApplicationState }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Links for the customer</CardTitle>
        <CardDescription>
          {state.sent
            ? 'Send them one so they can see their quotes.'
            : 'The confirm link works now; the others once the application is sent to carriers.'}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-6">
        {!state.sent && (
          <>
            <div className="flex flex-col items-start gap-2">
              <h3 className="text-ink text-sm font-semibold">Confirm link</h3>
              <p className="text-ink-500 text-sm">
                They check the application, fill in what&apos;s missing and confirm it, which sends it to
                carriers.
              </p>
              <ConfirmLinkDialog orgId={orgId}>
                <Button type="button" variant="outline">
                  <SendHorizontal /> Send the confirm link
                </Button>
              </ConfirmLinkDialog>
            </div>
            <Separator />
          </>
        )}
        <div className="flex flex-col gap-2">
          <h3 className="text-ink text-sm font-semibold">Sign-in link</h3>
          <p className="text-ink-500 text-sm">
            Signs them in on their quotes. They confirm their information there before they can buy.
          </p>
          <CustomerSignInLink orgId={orgId} link={state.link} />
        </div>
        <Separator />
        <ViewOnlyLink orgId={orgId} applicationId={state.application?.id ?? null} available={state.sent} />
        <Separator />
        <AuthorizationLinks orgId={orgId} state={state} />
      </CardContent>
    </Card>
  )
}
